// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* 主色调 - 暖橙色系（与小程序一致） */
  --primary: #ff6f20;
  --primary-light: #ff843d;
  --primary-gradient: linear-gradient(135deg, #ff843d 0%, #ff5e00 100%);
  --primary-bg: #fff7ed;
  --primary-bg-alt: #fff7ed;
  --primary-border: rgba(255,111,32,0.2);
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --text-white: #fff;
  --bg-primary: #fff;
  --bg-secondary: #f7f8fa;
  --bg-tertiary: #f9fafb;
  --bg-dark: #f3f4f6;
  --border-color: #e5e7eb;
  --border-light: #d1d5db;
  --danger: #ef4444;
  --success: #059669;
  --warning: #f59e0b;
  --orange: #ff6f20;
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 20px;
  --shadow-sm: 0 2px 8px rgba(0,0,0,0.06);
  --shadow-md: 0 4px 12px rgba(0,0,0,0.08);
  --shadow-lg: 0 8px 24px rgba(0,0,0,0.12);
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,qEAAqE;EACrE,qBAAqB;EACrB,yBAAyB;EACzB,sCAAsC;EACtC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;AAC1C","sourcesContent":[":root {\n  /* 主色调 - 暖橙色系（与小程序一致） */\n  --primary: #ff6f20;\n  --primary-light: #ff843d;\n  --primary-gradient: linear-gradient(135deg, #ff843d 0%, #ff5e00 100%);\n  --primary-bg: #fff7ed;\n  --primary-bg-alt: #fff7ed;\n  --primary-border: rgba(255,111,32,0.2);\n  --text-primary: #1f2937;\n  --text-secondary: #6b7280;\n  --text-muted: #9ca3af;\n  --text-white: #fff;\n  --bg-primary: #fff;\n  --bg-secondary: #f7f8fa;\n  --bg-tertiary: #f9fafb;\n  --bg-dark: #f3f4f6;\n  --border-color: #e5e7eb;\n  --border-light: #d1d5db;\n  --danger: #ef4444;\n  --success: #059669;\n  --warning: #f59e0b;\n  --orange: #ff6f20;\n  --radius-sm: 6px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 20px;\n  --shadow-sm: 0 2px 8px rgba(0,0,0,0.06);\n  --shadow-md: 0 4px 12px rgba(0,0,0,0.08);\n  --shadow-lg: 0 8px 24px rgba(0,0,0,0.12);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
